/* Collection toolbar: one dropdown open at a time, auto-submit filters and sort, keep the query string on tag links.
   Filtering is a normal page load so Flex's infinite scroll initialises against the fresh grid. */
(() => {
  const root = document.querySelector('[data-kj-collection]');
  if (!root || root.dataset.kjReady) return;
  root.dataset.kjReady = 'true';

  const form = root.querySelector('[data-kj-filters]');
  const dropdowns = [...root.querySelectorAll('[data-kj-dd]')];

  const closeAll = (except) => {
    dropdowns.forEach((dd) => {
      if (dd !== except) dd.open = false;
    });
  };

  dropdowns.forEach((dd) => {
    dd.addEventListener('toggle', () => {
      if (dd.open) closeAll(dd);
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-kj-dd]')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = dropdowns.find((dd) => dd.open);
    if (!open) return;
    open.open = false;
    open.querySelector('summary').focus();
  });

  if (form) {
    form.addEventListener('submit', () => {
      form.querySelectorAll('input[type="number"]').forEach((input) => {
        if (input.value === '') input.removeAttribute('name');
      });
      root.classList.add('is-loading');
    });
  }

  root.addEventListener('change', (event) => {
    if (form && event.target.matches('[data-kj-autosubmit]')) form.requestSubmit();
  });

  root.addEventListener('click', (event) => {
    const link = event.target.closest('[data-kj-keep-query]');
    if (!link) return;
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    const query = params.toString();
    if (!query) return;
    event.preventDefault();
    window.location.href = `${link.getAttribute('href')}?${query}`;
  });
})();
